import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import parse from 'html-react-parser';
import { wpKsesPost } from '../../dom/index.js';
/**
 * The `SafeHtml` component provides an easy way to safely render HTML
 *
 * The html prop is sanitized through {@link wpKsesPost} so it's safe for rendering arbitrary html markup.
 *
 * #### Usage
 *
 * ```jsx
 * <SafeHtml html="<div><p>hello world</p> div content</div>" />
 * ```
 *
 * @param props Component properties
 *
 * @category React Components
 */
export const SafeHtml = ({ html, ksesAllowList }) => {
    return _jsx(_Fragment, { children: parse(wpKsesPost(html, ksesAllowList)) });
};
